(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PharmaFaultSettings', PharmaFaultSettings);

    PharmaFaultSettings.$inject = ['$resource'];

    function PharmaFaultSettings ($resource) {
        var resourceUrl =  'api/pharma-fault-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
